import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { trpc } from "@/lib/trpcClient";
import { DraftReimbursementSheet } from "./-components/draft-reimbursement-sheet";
import { ReimbursementSheet } from "./-components/reimbursement-sheet";

export const Route = createFileRoute(
  "/_authed/_org/transactions/reimbursements/$id",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();

  const { data } = useSuspenseQuery(
    trpc.reimbursement.get.queryOptions({ reimbursementId: id }),
  );

  return data.request.status === "draft" ? (
    <DraftReimbursementSheet reimbursementId={id} />
  ) : (
    <ReimbursementSheet reimbursementId={id} />
  );
}
